import { Route } from 'react-router-dom';
import { personnePhysiqueSchema } from './personnePhysique';
import Main from '@app/main/tables/Main';
import { parrainageSchema } from '../Parrainage/parrainage';

/**
 * Routes configurées pour le module PersonnePhysique
 */
const PersonnePhysiqueRoutes = [
    // Route de liste (principale)
    <Route
        key="personnePhysiques-list"
        path="personnePhysiques"
        element={
            <Main
                key="personnePhysiques-main"
                pageConfig={personnePhysiqueSchema}
            />
        }
    />,
    // route pour afficher les parrainages d'une personne physique
    <Route
        key="personnePhysiques-parrainages"
        path="personnePhysiques/:id/parrainages"
        element={
            <Main
                key="personnePhysiques-parrainages-main"
                pageConfig={parrainageSchema}
            />
        }
    />,
    // route pour afficher les parrainages d'un accord de parrainage
    <Route
        key="accordDeParrainages-list"
        path="accordDe/:id/parrainages"
        element={
            <Main
                key="accordDeParrainages-main"
                pageConfig={parrainageSchema}
            />
        }
    />,
];

export default PersonnePhysiqueRoutes;
